import {BehaviorSubject} from 'rxjs';
import { ESRecord } from "./lib/ESRecord";

export interface IDateRange {
    StartDt?: Date,
    EndDt?: Date
}

export interface IIdentityProvider {
    readonly id: number | string;
    readonly id_ui: number | string;
    readonly name: string;
    readonly createdBy: number | string;
    readonly mdset: number | string;
    readonly company: number | string;
    readonly salesOrg: number | string;
    readonly salesArea: number | string;
    readonly IdentityChanged: BehaviorSubject<IIdentityProvider>;

    setAll(id?: number | string, id_ui?: number | string, name?: string, createdBy?: number | string): void;

    setId(id: number | string): void;

    setIdUI(id_ui: number | string): void;

    setName(name: string): void;

    setMDSet(value: number | string): void;

    setSalesOrg(value: number | string): void;

    setDataMart(value: number | string): void;

    //--
    readonly bHasIdUIWriteBack: boolean
    readonly bHasNameWriteBack: boolean

    addListener(anIdentityProvider: IIdentityProvider): void

    removeListener(anIdentityProvider: IIdentityProvider): void

    removeAllListeners(): void

}

export enum MessageType {
    Warning,
    Error,
    Information,
    Success,
    Progress,
    None
}

export interface IMessage {
    readonly code: string,
    readonly title: string,
    subtitle?: string,
    readonly description: string,
    readonly type: MessageType, // Warning/ Error
    readonly count?: number,
    readonly details?: any  // Tooltip, ParameterKeys for translation..
    time?: Date
}

export interface IMessageProvider {

    addMessage(aMsg: IMessage): void;

    addMessages(arrMsgs: IMessage[]): void;

    addTextMessages(MessageCodePrefix: string, aType: MessageType, pArrText: string[] | string): void

    removeMessage(MessageCode: string): void;

    clearMessages(): void;

    countMessages(aMessageType: MessageType): number;

    readonly Messages: IMessage[];
    readonly MessagesChanged: BehaviorSubject<IMessageProvider>;
}


export interface IProgressProvider {

    // Provider Side
    setName(name: string): void;

    start(name?: string): void;

    setProgressMessage(message_id: string, message_text: string): void;

    setPercentComplete(pcnt_complete: number): void;

    setProgressNumerator(numerator: number): void;

    setProgressDenominator(denominator: number): void;

    finish(): void;

    exception(anError: any): void;


    // Consumer Side
    readonly process_name: string;
    readonly process_running: boolean;
    readonly process_pcnt_complete: number;
    readonly process_progress_numerator: number;
    readonly process_progress_denominator: number;
    readonly process_completed: boolean;
    readonly process_failed: boolean;
    readonly process_exception: any;

    readonly progress_message_id: string;
    readonly progress_message_text: string;
    readonly ProgressChanged: BehaviorSubject<IProgressProvider>;
    readonly OnComplete: BehaviorSubject<IProgressProvider>;
    readonly process_parent: any;

    addListener(aProgressProvider: IProgressProvider): void

    addListenerUtilComplete(aProgressProvider: IProgressProvider): void

    removeListener(aProgressProvider: IProgressProvider): void

    removeAllListeners(): void

    // New Methods for Remote Listeners
    addWSListener(channelId: string, bRemoveOnComplete?: boolean): Promise<void>

    removeWSlistener(channelId: string): void

    removeAllWSListeners(): void

    // New Methods for Being a Listener
    //-- if channelId not specified, it will generate a channel Id
    listenOn(channelId?: string): Promise<void>

    listenOff(): void

    readonly listenOnChannelId: string

    // TODO Add Request Cancel, to allow cancel of remote processes
    //requestCancel(): Promise<void>
    //readonly requested_cancel: boolean
    //readonly canceled: boolean

}


export interface IMessengerMessage {
    messageType: string,

}

export interface IMessengerChannel {
    channelId: string,
    channelName: string,
    channelGroup: string
}

export interface IMessenger<T extends IMessengerMessage> {
    // Address Id, Channel Setup
    setChannel(channelId?: string, channelName?: string, channelGroup?: string): void

    getChannel(): IMessengerChannel

    // OutBox, Transmit API
    postMessage(message: T | T[]): Promise<boolean>

    readonly OutBoxLastMessage: T

    // Inbox, Listening API
    readonly bInboxEnabled: boolean

    enableInBox(): Promise<void>

    disableInBox(): void

    readonly OnInBoxMessageReceived: BehaviorSubject<{ messenger: IMessenger<T>, message: T }>
    readonly InBoxMessages: T[]
    readonly InBoxLastMessage: T
    readonly InBoxMaxMessageCount: number

    destroy(): void

    // TODO: Add Channel Directory Service, i.e. get list of Channels for a Group
}

export interface IEntitySource {
    readonly Entities: ESRecord[],
    readonly Selected: ESRecord[],
    readonly keyFields: {
        id: string,
        id_ui: string,
        name: string
    },

    addSelection(id: number): Promise<void>
    removeSelection(id: number): Promise<void>,
    readonly onChange: BehaviorSubject<any>
}
